import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHandbook } from '~/controllers/handbook';
import { Select } from 'antd';
import { useIsMobile } from '~/hooks/useScreenSizes';
import styled from 'styled-components';
import placeholder from 'lodash/fp/placeholder';

function DynamicSelect(props: any) {
  const { dropdownKey, optionsBackUp } = props;
  const { t } = useTranslation('fillApplication');
  const handbook = useHandbook();
  const options = handbook.data?.handbooks
    ?.find((item: any) => item.key === dropdownKey)
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ?.values?.map((item: any) => ({
      label: item.localizedValue,
      value: item.apiValue?.replace(/\s+/g, ''),
      key: item.key,
    }));
  const isMobile = useIsMobile();

  return (
    <Container isMobile={isMobile}>
      <Select
        style={{
          width: isMobile ? '100%' : '100%',
        }}
        loading={handbook.isLoading}
        disabled={handbook.isLoading}
        showSearch
        options={options || optionsBackUp}
        {...props}
        placeholder={
          <span
            style={{
              position: 'absolute',
              bottom: 2,
              width: '90%',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {props?.placeholder}
          </span>
        }
      />
    </Container>
  );
}

export const Container = styled.div<any>`
  .ant-select-selection-item {
    max-width: ${({ isMobile }) => (isMobile ? '250px' : '100%')};
  }
`;
export default DynamicSelect;
